global.documentsRoute='https://charisma-formation.fr/documents/';
global.api = "https://charisma-formation.fr/api/charisma"